import { useChatRouterRefs } from './useChatRouterRefs'
import { useChatPersistedSlices } from './useChatPersistedSlices'

export function usePersistedChatState() {
  return { ...useChatRouterRefs(), ...useChatPersistedSlices() }
}
